import { Observable, Observer } from "rxjs";
import { HTTP_METHOD } from "../../constants/http";
import { AxiosSubscriber } from "../AxiosSubscriber";
import { INotificationPriorityModel } from "../../models";
import { PromisifiableBase } from "../Base/PromisifiableBase";

export class NotificationPrioritiesService extends PromisifiableBase {
  get url(): string {
    return "/NotificationPriorities";
  }

  public select = (): Observable<INotificationPriorityModel[]> =>
    new Observable(
      (observer: Observer<INotificationPriorityModel[]>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.GET,
          url: `${this.url}/Select`,
        })
    );
}
